import BarChartContainer from './bar-chart-container';
export { default as Histogram } from './histogram';

export default BarChartContainer;
